module.exports = __webpack_public_path__ + "static/media/b2_p12_clickable.2ac00a08.mp3";